import React from 'react';

import defaultImage from '../../../../../assets/images/browser-check/browser-check-image.jpg';
import {DualLayout} from '../../../../components/DataDisplay';
import AppLoaderMedia from '../../../../components/Loader/AppLoader/AppLoaderMedia';
import appConfig from '../../../../config/appConfig';
import * as localizationKeys from '../../../../consts/localization/localizationKeys';
import userDeviceService from '../../../../services/user/userDeviceService';
import SignedImage from '../../../System/SignedImage';

const BrowserVerificationComponent = () => {
    const isMobileDevice = userDeviceService.isMobileDevice();
    const browserCheckImagePath = appConfig.getBrowserCheckPageImagePath();

    const titleKey = isMobileDevice
        ? localizationKeys.BROWSER_VERIFICATION_MOBILE_TITLE
        : localizationKeys.BROWSER_VERIFICATION_DESKTOP_TITLE;

    return (
        <DualLayout
            className='lg:py-16'
            classNameLeft='xl:p-0'
            classNameRight='flex items-center justify-center'
            articleProps={{
                titleKey,
                className: 'text-center',
                titleClassName: 'mb-3 mt-8 lg:mt-0 lg:mb-9',
                descriptionKey: localizationKeys.BROWSER_VERIFICATION_TEXT,
                children: (
                    <div className='relative mx-auto py-20'>
                        <AppLoaderMedia />
                    </div>
                ),
            }}
        >
            <SignedImage
                imgClassName='h-[212px] w-full object-cover bg-center md:h-[420px] lg:h-[540px]'
                isThumbnailAvailable
                defaultImage={defaultImage}
                mediaData={browserCheckImagePath}
                signIfNull
            />
        </DualLayout>
    );
};

export default BrowserVerificationComponent;
